<template>
  <div class="main">
    <div class="banner">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in bannerList4Obj" :key="index">
            <img v-if="item.type == 0" :src="item.url" />
            <video v-else :id="'video_' + index" :src="item.url" style="width:100%; height: 100%;" preload="auto"
              muted="true"></video>
          </div>
        </div>
        <div class="swiper-button-prev" v-if="showBtn"></div>
        <div class="swiper-button-next" v-if="showBtn"></div>
      </div>
    </div>
    <div style="background-color: #f1f6fe;">
      <div class="ad-box">
        <div class="ad-title">
          <div class="index-label">新闻动态</div>
          <div class="sub-title">
            <div class="sub-title-item" :class="newsIndex == 0 ? 'active' : ''" @mouseenter="clickNewsType(0)"
              @click="clickNewsType(0)">头条新闻</div>
            <div class="sub-title-item" :class="newsIndex == 2 ? 'active' : ''" @mouseenter="clickNewsType(2)"
              @click="clickNewsType(2)">媒体聚焦</div>
            <div class="sub-title-item" :class="newsIndex == 1 ? 'active' : ''" @mouseenter="clickNewsType(1)"
              @click="clickNewsType(1)">最新通知</div>
          </div>
        </div>
        <div class="ad-mian">
          <div v-show="newsIndex == 0">
            <div class="news" v-if="showNews">
              <div class="swiper-container">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" v-for="(item, index) in newsArray1" :key="index">
                    <div class="item" @click="navToyjyxwDetail(item.article_id, item.redirection_address)">
                      <img :src="item.title_img_path" />
                      <div class="text-box">
                        <div class="date">{{ item.publish_time ? item.publish_time.substring(0, 10) : "--" }}</div>
                        <div class="title">{{ item.article_title }}</div>
                        <div class="content">{{ item.article_desc }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-pagination"></div>
              </div>
            </div>
            <div class="newsList" v-if="showNews">
              <div class="news-item" v-for="(item, index) in newsArray2" :key="index"
                @click="navToyjyxwDetail(item.article_id, item.redirection_address)">
                <img :src="item.title_img_path" />
                <div class="text-box">
                  <div class="title">{{ item.article_title }}</div>
                  <div class="date">{{ item.publish_time ? item.publish_time.substring(0, 10) : "--" }}</div>
                </div>
                <div class="hover-show">
                  <img :src="item.title_img_path" />
                  <div class="txt">
                    <div>
                      <div class="title">{{ item.article_title }}</div>
                      <div class="date">{{ item.publish_time ? item.publish_time.substring(0, 10) : "--" }}</div>
                    </div>
                    <div class="navToDetail">查看详情</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="newsIndex == 2">
            <div class="clearfix medium-box">
              <div class="medium-width"
                @click="navToyjyxwDetail(mediumArray1.article_id, mediumArray1.redirection_address)">
                <div class="medium-width-box">
                  <div class="medium-width-img" v-if="mediumArray1.dynamic_data && mediumArray1.title_img_path">
                    <img :src="mediumArray1.title_img_path" />
                  </div>
                  <div class="medium-width-bottom">
                    <div class="medium-date">
                      <span>{{ mediumArray1.publish_time ? mediumArray1.publish_time.substring(8, 10) : "--" }}</span>
                      <br>{{ mediumArray1.publish_time ? mediumArray1.publish_time.substring(0, 7) : "--" }}
                    </div>
                    <div class="medium-title">{{ mediumArray1.article_title }}</div>
                    <div class="medium-width-p">{{ mediumArray1.article_desc }}</div>
                    <span class="medium-link-span">查看详情</span>
                  </div>
                </div>
              </div>
              <div class="medium-width">
                <div class="medium-width-box">
                  <ul class="medium-width-news">
                    <li v-for="(item, index) in mediumArray2" :key="'mtjj_' + index"
                      @click="navToyjyxwDetail(item.article_id, item.redirection_address)">
                      <a href="javascript:void(0)" class="clearfix">
                        <i></i>
                        <div class="medium-date">
                          <span>{{ item.publish_time ? item.publish_time.substring(8, 10) : "--" }}</span>
                          <br>{{ item.publish_time ? item.publish_time.substring(0, 7) : "--" }}
                        </div>
                        <div class="medium-width-news-right">
                          <div class="medium-width-news-tt">{{ item.article_title }}</div>
                          <div class="medium-width-p">{{ item.article_desc }}</div>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div v-show="newsIndex == 1">
            <div class="news-box-c clearfix">
              <div class="news-box-w">
                <ul class="clearfix news-box-sm">
                  <li :class="index == 0 ? 'active' : ''" v-for="(item, index) in noticeArray1" :key="'zxtz_' + index"
                    @click="navToyjyxwDetail(item.article_id, item.redirection_address)">
                    <a href="javascript:void(0)" class="clearfix">
                      <div class="xz-date">
                        <span>{{ item.publish_time ? item.publish_time.substring(8, 10) : "--" }}</span>
                        <br>{{ item.publish_time ? item.publish_time.substring(0, 7) : "--" }}
                      </div>
                      <div class="xz-width-news-right">
                        <div class="xz-width-news-tt">{{ item.article_title }}</div>
                        <div class="xz-width-p">{{ item.article_desc }}</div>
                      </div>
                    </a>
                  </li>
                </ul>
                <ul class="clearfix news-box-sm">
                  <li v-for="(item, index) in noticeArray2" :key="'zxtz2_' + index"
                    @click="navToyjyxwDetail(item.article_id, item.redirection_address)">
                    <a href="javascript:void(0)" class="clearfix">
                      <div class="xz-date"><span>{{ item.publish_time ? item.publish_time.substring(8, 10) :
                        "--" }}</span><br>{{ item.publish_time ? item.publish_time.substring(0, 7) : "--" }}</div>
                      <div class="xz-width-news-right">
                        <div class="xz-width-news-tt">{{ item.article_title }}</div>
                        <div class="xz-width-p">{{ item.article_desc }}</div>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="img-b" style="opacity: 0.4;"><a><img src="../../assets/image/a01-1.jpg"></a></div>
            </div>
          </div>
          <div class="btn">
            <a href="javascript:void(0);" @click="navToyjyxwList()">了解更多</a>
          </div>
        </div>
      </div>
    </div>
    <div class="index-s3">
      <div class="xl">
        <div class="top-block">
          <div class="index-wrap">
            <div class="index-label">科研创新</div>
            <div class="tab-cont">
              <div class="sw">
                <div class="child" :class="index == xueshudongtaiIndex ? 'active' : ''"
                  v-for="(item, index) in xueshudongtaiList" :key="index">
                  <div class="flex">
                    <div class="img-box">
                      <img :src="item.title_img_path" alt="">
                    </div>
                    <div class="txt-box">
                      <div class="date">{{ item.publish_time ? item.publish_time.substring(0, 10) : "--" }}</div>
                      <div class="tit">{{ item.article_title }}</div>
                      <p>{{ item.article_desc }}</p>
                      <div class="btn">
                        <a href="javascript:void(0);"
                          @click="navToxsdtDetail(item.article_id, item.redirection_address)">查看详情</a>
                        <a href="javascript:void(0);" @click="navToxsdtList()">了解更多</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bot-block">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="item swiper-slide" :class="index == xueshudongtaiIndex ? 'active' : ''"
                v-for="(item, index) in xueshudongtaiList" :key="'xsdt_' + index"
                @mouseenter="xueshudongtaiClick(index)" @click="xueshudongtaiClick(index)">
                <div class="tit">
                  {{ item.article_title }}
                </div>
              </div>
            </div>
            <div class="button prev" @click="xueshudongtaiPrev"></div>
            <div class="button next" @click="xueshudongtaiNext"></div>
          </div>

        </div>
      </div>

      <div class="sm">
        <!-- 小屏 -->
        <div class="top-block">
          <div class="index-wrap">
            <div class="index-label">科研创新</div>
            <div class="tab-cont">
              <div class="sw">
                <div class="kycx2-swiper-container">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item, index) in xueshudongtaiList" :key="index">

                      <div class="flex1">
                        <div class="img-box">
                          <img :src="item.title_img_path" alt="">
                        </div>
                        <div class="txt-box">
                          <div class="date">{{ item.publish_time ? item.publish_time.substring(0, 10) : "--" }}</div>
                          <div class="tit">{{ item.article_title }}</div>
                          <p>{{ item.article_desc }}</p>
                          <div class="btn">
                            <a href="javascript:void(0);"
                              @click="navToxsdtDetail(item.article_id, item.redirection_address)">查看详情</a>
                            <a href="javascript:void(0);" @click="navToxsdtList()">了解更多</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-pagination"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="index-s4">
      <div class="items xl">
        <div class="sw">
          <div class="item zt3" data-start="2024-10-21 15:33:48" data-end=""
            v-for="(item, index) in jiangzuobaogaoList1" :key="'jzbg_' + index">
            <div class="img-box" :class="'img-box1_' + index"></div>
            <div class="show">
              <span>讲座报告</span>
              <div class="tit">{{ item.article_title }}<br></div>
            </div>
            <div class="hide">
              <div class="tit">{{ item.article_title }}<br></div>
              <div class="info">
                <p class="date">{{ item.dynamic_data ? (item.dynamic_data.time || "") : "" }}</p>
                <p class="addr">{{ item.dynamic_data ? (item.dynamic_data.address || "") : "" }}</p>
                <p class="speaker">{{ item.dynamic_data ? (item.dynamic_data.lecturer || "") : "" }}</p>
              </div>
              <div class="btn">
                <a href="javascript:void(0);"
                  @click="navTojzbgDetail(item.article_id, item.redirection_address)">查看详情</a>
                <a href="javascript:void(0);" @click="navTojzbgList()">了解更多</a>
              </div>
            </div>
          </div>
          <div class="item zt3" data-start="2024-10-21 15:33:48" data-end=""
            v-for="(item, index) in jiangzuobaogaoList2" :key="index">
            <div class="img-box" :class="'img-box2_' + index"></div>
            <div class="show">
              <span>学生风采</span>
              <div class="tit">{{ item.article_title }}<br></div>
            </div>
            <div class="hide">
              <div class="tit">{{ item.article_title }}<br></div>
              <div class="info">
                <p class="date">{{ item.dynamic_data ? (item.dynamic_data.time || "") : "" }}</p>
                <p class="addr">{{ item.dynamic_data ? (item.dynamic_data.address || "") : "" }}</p>
                <p class="speaker">{{ item.dynamic_data ? (item.dynamic_data.lecturer || "") : "" }}</p>
              </div>
              <div class="btn">
                <a href="javascript:void(0);"
                  @click="navTojzbgDetail1(item.article_id, item.redirection_address)">查看详情</a>
                <a href="javascript:void(0);" @click="navTojzbgList1()">了解更多</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="items sm">
        <div class="index-label">讲座报告</div>
        <div class="jzbg-swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in jiangzuobaogaoList1" :key="'jzbg_' + index">
              <div class="item">
                <div class="img-box" :class="'img-box1_' + index"></div>
                <div class="hide">
                  <div class="tit">{{ item.article_title }}<br></div>
                  <div class="info">
                    <p class="date">{{ item.dynamic_data ? (item.dynamic_data.time || "") : "" }}</p>
                    <p class="addr">{{ item.dynamic_data ? (item.dynamic_data.address || "") : "" }}</p>
                    <p class="speaker">{{ item.dynamic_data ? (item.dynamic_data.lecturer || "") : "" }}</p>
                  </div>
                  <div class="btn">
                    <a href="javascript:void(0);"
                      @click="navTojzbgDetail(item.article_id, item.redirection_address)">查看详情</a>
                    <a href="javascript:void(0);" @click="navTojzbgList()">了解更多</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
        <div class="index-label">研究生风采</div>
        <div class="yjsfc-swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in jiangzuobaogaoList2" :key="'yjsfc_' + index">
              <div class="item">
                <div class="img-box" :class="'img-box2_' + index"></div>
                <div class="hide">
                  <div class="tit">{{ item.article_title || "" }}<br></div>
                  <div class="info">
                    <p class="date">{{ item.dynamic_data ? (item.dynamic_data.time || "") : "" }}</p>
                    <p class="addr">{{ item.dynamic_data ? (item.dynamic_data.address || "") : "" }}</p>
                    <p class="speaker">{{ item.dynamic_data ? (item.dynamic_data.lecturer || "") : "" }}</p>
                  </div>
                  <div class="btn">
                    <a href="javascript:void(0);"
                      @click="navTojzbgDetail1(item.article_id, item.redirection_address)">查看详情</a>
                    <a href="javascript:void(0);" @click="navTojzbgList1()">了解更多</a>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>
    <div class="index-s5">
      <div class="index-wrap">
        <div class="index-label">人物推荐</div>
        <div class="items xl">
          <div class="sw">
            <div class="xs5item" :class="index == 0 ? 'active' : ''" v-for="(item, index) in meiyuerenwutuijianList"
              :key="index" @mouseenter="mouseenter">
              <div class="img-box">
                <img :src="item.title_img_path">
              </div>
              <div class="show">
                <!-- <i style="background-image: url(../../assets/image/index/icon-2-1.png);"></i> -->
                <div class="tit">{{ item.article_title }}</div>
              </div>
              <div class="hide">
                <div class="tit">{{ item.article_title }}</div>
                <p>{{ item.article_desc }}</p>
                <span @click="navTomyrwtjDetail(item.article_id)">查看详情</span>
              </div>
            </div>
          </div>
        </div>
        <div class="items sm">
          <div class="rwtj-swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item, index) in meiyuerenwutuijianList" :key="'rwtj_' + index">
                <div class="item" @click="navTomyrwtjDetail(item.article_id)">
                  <div class="img-box">
                    <img :src="item.title_img_path">
                  </div>
                  <div class="tit">{{ item.article_title }}</div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
        <div class="btn">
          <a href="javascript:void(0);" @click="navTomyrwtjList()">了解更多</a>
        </div>
      </div>
    </div>
    <div class="index-s8">
      <div class="top-block">
        <!-- 数说创新院 -->
        <img src="../../assets/image/img-15.png" alt="">
      </div>
      <div class="bot-block">
        <div class="item">
          <div class="box">
            <div class="icon icon1"></div>
            <span class="count" data-counter-time="500">7412.67</span>
          </div>
          <p>科研项目经费(万元)<br><br></p>
        </div>
        <div class="item">
          <div class="box">
            <div class="icon icon2"></div>
            <span class="count" data-counter-time="500">71</span>
          </div>
          <p>发明专利<br><br></p>
        </div>
        <div class="item">
          <div class="box">
            <div class="icon icon3"></div>
            <span class="count" data-counter-time="500">12</span>
          </div>
          <p>行业标准<br><br></p>
        </div>
        <div class="item">
          <div class="box">
            <div class="icon icon4"></div>
            <span class="count" data-counter-time="500">106</span>
          </div>
          <p>社会服务<br><br></p>
        </div>
        <div class="item">
          <div class="box">
            <div class="icon icon5"></div>
            <span class="count" data-counter-time="500">205</span>
          </div>
          <p>科研团队(人)<br><br></p>
        </div>
        <div class="item">
          <div class="box">
            <div class="icon icon6"></div>
            <span class="count" data-counter-time="500">137</span>
          </div>
          <p>入驻研究生<br><br></p>
        </div>
        <div class="item">
          <div class="box">
            <div class="icon icon7"></div>
            <span class="count" data-counter-time="500">3000</span>
          </div>
          <p>科研设备价值(万元)<br><br></p>
        </div>
      </div>

      <img class="bg-img" src="../../assets/image/img-14-2.png">
    </div>
  </div>
</template>
<script>
import { watch } from 'less';
import Swiper from 'swiper'
import { NavigationFailureType } from 'vue-router';
export default {
  data() {
    return {
      showNews: false,
      xueshudongtaiIndex: 0,
      newsIndex: 0,
      newsArray1: [],
      newsArray2: [],
      noticeArray1: [],
      noticeArray2: [],
      mediumArray1: {},
      mediumArray2: [],
      xueshudongtaiList: [],
      jiangzuobaogaoList1: [],
      jiangzuobaogaoList2: [],
      meiyuerenwutuijianList: [],
      bannerList4Obj: [
        { type: 0, url: "http://qiniu.syshunying.cn/qiniu/uploads/home-banner-1.jpg" },
        { type: 0, url: "http://qiniu.syshunying.cn/qiniu/uploads/home-banner-2.jpg" },
        { type: 0, url: "http://qiniu.syshunying.cn/qiniu/uploads/home-banner-3.jpg" },
        { type: 1, url: "http://qiniu.syshunying.cn/qiniu/uploads/1.mp4" },
        { type: 1, url: "http://qiniu.syshunying.cn/qiniu/uploads/2.mp4" },
        { type: 1, url: "http://qiniu.syshunying.cn/qiniu/uploads/3.mp4" },
      ],

      showIndex: 0,
      timer: null,
      showBtn: true,
    }
  },
  created() {

    this.getInfoList()
    this.Getbanner()
    this.$nextTick(function () {
      new Swiper(".banner .swiper-container", {
        effect: "fade",
        direction: 'horizontal',
        followFinger: true,
        speed: 800,
        mousewheel: false,
        autoplay: true,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
          slideChangeTransitionStart: function () {
            let t = this;
            let index = this.activeIndex
            let domeObj = document.querySelectorAll(".banner .swiper-container .swiper-slide")[index].firstChild;
            let type = domeObj.nodeName.toLowerCase();
            if (type == 'img') {
              this.autoplay.start()
            } else if (type == 'video') {
              this.autoplay.stop()
              domeObj.load()
              setTimeout(() => {
                domeObj.play()
              }, 500);
              domeObj.addEventListener('ended', function () { // 视频播放结束
                t.autoplay.start()
              })
            }
          },
        },
      });
    })
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  watch: {
    newsArray1: {
      immediate: true,
      handler() {
        this.$nextTick(function () {
          new Swiper(".news .swiper-container", {
            effect: "fade",
            direction: 'horizontal',
            followFinger: true,
            speed: 800,
            mousewheel: false,
            autoplay: true,
            loop: true,
            pagination: {
              el: '.news .swiper-pagination',
              clickable: true,//设置小原店面可以切换
            },
            on: {
              init: function (swiper) {
                let self = this
                setTimeout(() => {
                  var slide = self.slides[1];
                  if (slide) {
                    slide.classList.add('ani-slide');
                  }
                }, 500);
              },
              transitionStart: function () {
                for (var i = 0; i < this.slides.length; i++) {
                  var slide = this.slides[i];
                  if (slide) {
                    slide.classList.remove('ani-slide');
                  }
                }
              },
              transitionEnd: function () {
                var slide = this.slides[this.activeIndex];
                if (slide) {
                  slide.classList.add('ani-slide');
                }
              },
            }
          });
        })
      }
    },
    xueshudongtaiList: {
      immediate: true,
      handler() {
        this.$nextTick(function () {
          new Swiper(".index-s3 .xl .swiper-container", {
            speed: 500,
            slidesPerView: 3,
            // simulateTouch: false,
            breakpoints: {
              1681: {
                slidesPerView: 5,
              },
              1441: {
                slidesPerView: 4,
              }
            },
            navigation: {
              nextEl: '.button.next',
              prevEl: '.button.prev',
            },
          });
          new Swiper(".index-s3 .kycx2-swiper-container", {
            direction: 'horizontal',
            followFinger: false,
            speed: 800,
            mousewheel: false,
            autoplay: true,
            loop: true,
            pagination: {
              el: '.index-s3 .kycx2-swiper-container .swiper-pagination',
              clickable: true,//设置小原店面可以切换
            },
          });
        })
      }
    },
    jiangzuobaogaoList1: {
      immediate: true,
      handler() {
        this.$nextTick(function () {
          new Swiper(".jzbg-swiper-container", {
            direction: 'horizontal',
            followFinger: false,
            speed: 800,
            mousewheel: false,
            autoplay: false,
            loop: true,
            pagination: {
              el: '.jzbg-swiper-container .swiper-pagination',
              clickable: true,//设置小原店面可以切换
            },
          });
        })
      }
    },
    jiangzuobaogaoList2: {
      immediate: true,
      handler() {
        this.$nextTick(function () {
          new Swiper(".yjsfc-swiper-container", {
            direction: 'horizontal',
            followFinger: false,
            speed: 800,
            mousewheel: false,
            autoplay: false,
            loop: true,
            pagination: {
              el: '.yjsfc-swiper-container .swiper-pagination',
              clickable: true,//设置小原店面可以切换
            },
          });
        })
      }
    },
    meiyuerenwutuijianList: {
      immediate: true,
      handler() {
        this.$nextTick(function () {
          new Swiper(".rwtj-swiper-container", {
            direction: 'horizontal',
            followFinger: false,
            speed: 800,
            mousewheel: false,
            autoplay: false,
            loop: true,
            pagination: {
              el: '.rwtj-swiper-container .swiper-pagination',
              clickable: true,//设置小原店面可以切换
            },
          });
        })
      }
    },
    showIndex: {
      handler(newValue) {
        if (this.bannerList4Obj[this.showIndex].type == '1') {
          this.$nextTick(() => {
            let videoObj = document.getElementById("video_" + this.showIndex)
            videoObj.play()
          });
        } else {
          setTimeout(() => {
            this.showIndex = this.showIndex + 1
          }, 6000);
        }
      },
    }
  },
  mounted() {
  },
  methods: {
    clickNewsType(type) {
      this.newsIndex = type
    },
    xueshudongtaiPrev() {
      this.xueshudongtaiIndex--;
      if (this.xueshudongtaiIndex < 0) {
        this.xueshudongtaiIndex = 0
      }
    },
    xueshudongtaiNext() {
      this.xueshudongtaiIndex++;
      if (this.xueshudongtaiIndex > this.xueshudongtaiList.length - 1) {
        this.xueshudongtaiIndex = this.xueshudongtaiList.length - 1
      }
    },
    xueshudongtaiClick(index) {
      this.xueshudongtaiIndex = index;
    },
    mouseenter4news(e) {
      e.target.style.opacity = 1;
    },
    mouseleave4news(e) {
      e.target.style.opacity = 0;
    },
    mouseenter(e) {
      var activeObj = document.querySelector(".xs5item.active");
      if (activeObj) {
        activeObj.classList.remove("active");
        e.target.classList.add("active");
      }
    },
    handleMouseEnter() {
      this.showBtn = true
    },
    handleMouseLeave() {
      this.showBtn = false
    },
    handlePrev() {
      if (this.showIndex == 0) {
        this.showIndex = this.bannerList4Obj.length - 1
      } else {
        this.showIndex = this.showIndex - 1
      }
    },
    handleNext() {
      if (this.showIndex == this.bannerList4Obj.length - 1) {
        this.showIndex = 0
      } else {
        this.showIndex = this.showIndex + 1
      }
    },
    showPage() {
      // this.$router.push({ path: "/yxgl" });
    },

    getInfoList() {
      let self = this;
      // 新闻动态
      this.$common.noLoginCallUrl('/api/cp-cms/site/info/getInfoPage', {
        column_id: '751102554689617920',
        pageNo: 1,
        pageCount: 7
      },
        function (res) {
          self.newsArray1 = []
          self.newsArray2 = []
          if (res.code == '000000') {
            self.showNews = res.data.data.length > 0 ? true : false
            self.newsArray1 = res.data.data.slice(0, 3)
            self.newsArray2 = res.data.data.slice(3, 7)
          }

        })
      // 最新通知
      this.$common.noLoginCallUrl('/api/cp-cms/site/info/getInfoPage', {
        column_id: '751102878049484800',
        pageNo: 1,
        pageCount: 5
      },
        function (res) {
          self.noticeArray1 = []
          self.noticeArray2 = []
          if (res.code == '000000') {
            self.noticeArray1 = res.data.data.slice(0, 2)
            self.noticeArray2 = res.data.data.slice(2, 5)
          } else {
            self.$message.warning(res.msg)
          }
        })
      // 媒体聚焦
      this.$common.noLoginCallUrl('/api/cp-cms/site/info/getInfoPage', {
        column_id: '761169242527981568',
        pageNo: 1,
        pageCount: 5
      },
        function (res) {
          self.mediumArray1 = {}
          self.mediumArray2 = []
          if (res.code == '000000') {
            self.mediumArray1 = res.data.data[0]
            self.mediumArray2 = res.data.data.slice(1, 5)
          } else {
            self.$message.warning(res.msg)
          }
        })
      // 科研创新
      this.$common.noLoginCallUrl('/api/cp-cms/site/info/getInfoPage', {
        column_id: '751103586014445568',
        pageNo: 1,
        pageCount: 6
      },
        function (res) {
          self.xueshudongtaiList = []
          if (res.code == '000000') {
            self.xueshudongtaiList = res.data.data
          } else {
            self.$message.warning(res.msg)
          }
        })


      // 讲座报告
      this.$common.noLoginCallUrl('/api/cp-cms/site/info/getInfoPage', {
        column_id: '751103183470313472',
        pageNo: 1,
        pageCount: 3
      }, function (res) {
        if (res.code == '000000') {
          self.jiangzuobaogaoList1 = res.data.data
        } else {
          self.$message.warning(res.msg)
        }
      })
      // 讲座报告2（研究生风采）
      this.$common.noLoginCallUrl('/api/cp-cms/site/info/getInfoPage', {
        column_id: '756814689499463680',
        pageNo: 1,
        pageCount: 3
      }, function (res) {
        if (res.code == '000000') {
          self.jiangzuobaogaoList2 = res.data.data
        } else {
          self.$message.warning(res.msg)
        }
      })
      // Promise.all([jzbg_list1, jzbg_list2]).then(res => {
      //   self.jiangzuobaogaoList1 = []
      //   self.jiangzuobaogaoList2 = []
      //   if (res[0]) {
      //     if (res[0].code == '000000') {
      //       self.jiangzuobaogaoList1 = res[0].data.data
      //       self.jiangzuobaogaoList = self.jiangzuobaogaoList.concat(self.jiangzuobaogaoList1)
      //     } else {
      //       self.$message.warning(res[0].msg)
      //     }
      //   }
      //   if (res[1]) {
      //     if (res[1].code == '000000') {
      //       self.jiangzuobaogaoList2 = res[1].data.data
      //       self.jiangzuobaogaoList = self.jiangzuobaogaoList.concat(self.jiangzuobaogaoList2)
      //     } else {
      //       self.$message.warning(res[1].msg)
      //     }
      //   }
      // })
      // 每月人物推荐
      this.$common.noLoginCallUrl('/api/cp-cms/site/info/getInfoPage', {
        column_id: '751102974375870464',
        pageNo: 1,
        pageCount: 4
      },
        function (res) {
          self.meiyuerenwutuijianList = []
          if (res.code == '000000') {
            self.meiyuerenwutuijianList = res.data.data
            // self.meiyuerenwutuijianList.push(res.data.data)
          } else {
            self.$message.warning(res.msg)
          }
          // self.meiyuerenwutuijianList = self.meiyuerenwutuijianList.concat(res.data.data)
          // self.meiyuerenwutuijianList = self.meiyuerenwutuijianList.concat(res.data.data)
        })
    },
    Getbanner() {
      // 轮播图
      this.$common.noLoginApiAxios4GET('/cp-cms/system/site/url',  function (res) {
        if (res.code == '000000') {
          self.bannerList = res.data.data
        } else {
          self.$message.warning(res.msg)
        }
      })
    },
    navToyjyxwList() {
      let id, column_name, type;
      if (this.newsIndex == 0) {
        id = '751102554689617920'
        column_name = '新闻动态'
        type = 1
      } else if (this.newsIndex == 1) {
        id = '751102878049484800'
        column_name = '最新通知'
        type = 4
      } else {
        id = '761169242527981568'
        column_name = '媒体聚焦'
        type = 1
      }
      this.$router.push({
        path: "/sylmList",
        query: {
          column_id: id,
          type: type,
          column_name: column_name,
        }
      });
    },
    navToyjyxwDetail(id, url) {
      if (url) {
        window.open(url)
      } else {
        let column_name = "", type = 1;;
        if (this.newsIndex == 0) {
          column_name = '新闻动态'
        } else if (this.newsIndex == 1) {
          column_name = '最新通知'
        } else {
          column_name = '媒体聚焦'
        }
        this.$router.push({
          path: "/sylmDetail",
          query: {
            article_id: id,
            column_name: column_name
          }
        });
      }
    },
    navToxsdtList() {
      let id = '751103586014445568',
        column_name = '科研创新',
        type = 1;
      this.$router.push({
        path: "/sylmList",
        query: {
          column_id: id,
          type: type,
          column_name: column_name,
        }
      });
    },
    navToxsdtDetail(id, url) {
      if (url) {
        window.open(url)
      } else {
        let column_name = '科研创新';
        this.$router.push({
          path: "/sylmDetail",
          query: {
            article_id: id,
            column_name: column_name
          }
        });
      }
    },
    navTojzbgList() {
      let id = '751103183470313472',
        column_name = '讲座报告',
        type = 1;
      this.$router.push({
        path: "/sylmList",
        query: {
          column_id: id,
          type: type,
          column_name: column_name,
        }
      });
    },
    navTojzbgDetail(id, url) {
      if (url) {
        window.open(url)
      } else {
        let column_name = '讲座报告';
        this.$router.push({
          path: "/sylmDetail",
          query: {
            article_id: id,
            column_name: column_name
          }
        });
      }
    },
    navTojzbgList1() {
      let id = '756814689499463680',
        column_name = '研究生风采',
        type = 1;
      this.$router.push({
        path: "/sylmList",
        query: {
          column_id: id,
          type: type,
          column_name: column_name,
        }
      });
    },
    navTojzbgDetail1(id, url) {
      if (url) {
        window.open(url)
      } else {
        let column_name = '研究生风采';
        this.$router.push({
          path: "/sylmDetail",
          query: {
            article_id: id,
            column_name: column_name
          }
        });
      }
    },
    navTomyrwtjList() {
      let id = '751102974375870464',
        column_name = '人物推荐',
        type = 1;
      this.$router.push({
        path: "/sylmList",
        query: {
          column_id: id,
          type: type,
          column_name: column_name,
        }
      });
    },
    navTomyrwtjDetail(id) {
      let column_name = '人物推荐';
      this.$router.push({
        path: "/sylmDetail",
        query: {
          article_id: id,
          column_name: column_name
        }
      });
    }
  }
}
</script>
<style lang="less" scoped>
@keyframes o-upfade-top {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.xueshudongtai {
  .swiper-container {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    text-align: center;
    font-size: 18px;
    opacity: 1;

    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    transition: 300ms;
    transform: scale(0.8);

    .item {
      // width: 250px;
      background: #fff;
      height: 340px;
      border-radius: 8px;
    }
  }

  .swiper-slide-active,
  .swiper-slide-duplicate-active {
    transform: scale(1);
    opacity: 1;
  }
}

.newsList {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  .news-item {
    position: relative;

    border-radius: 8px;
    overflow: hidden;
    background-color: #fff;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);

    &:hover {
      .hover-show {
        opacity: 1;
      }
    }

    img {
      height: 155px;
      width: 100%;
    }

    .text-box {
      padding: 24px 30px;

      .title {
        font-size: 16px;
        line-height: 1.2;
        color: #3e3a39;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .date {
        font-size: 12px;
        line-height: 20px;
        color: #bfbfbf;
        margin-top: 10px;
      }
    }


  }

  .hover-show {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // background-color: #fff;
    color: #fff;
    z-index: 2;
    opacity: 0;
    transition: opacity .3s ease;

    img {
      width: 100%;
      height: 100%;
    }

    .txt {
      position: absolute;
      z-index: 3;
      padding: 60px;
      height: 100%;
      top: 0;
      left: 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      box-sizing: border-box;
    }

    .title {
      font-size: 16px;
      color: #fff;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .date {
      font-size: 12px;
      color: #fff;
      margin-top: 10px;
      display: block;
    }

    .navToDetail {
      width: 100px;
      line-height: 36px;
      text-align: center;
      font-size: 14px;
      color: #fff;
      border: 1px solid #fff;
    }

    &:after {
      content: '';
      width: 100%;
      height: 90%;
      position: absolute;
      bottom: 0;
      left: 0;
      background-image: linear-gradient(180deg, transparent, #8c1c40);
      z-index: 2
    }
  }
}

.news {
  box-shadow: 0 5px 30px rgba(0, 0, 0, 0.1);
  background: #fff;
  border-radius: 8px;

  .swiper-wrapper {
    transition-delay: .3s;

  }

  .swiper-container {
    width: 100%;
    height: 100%;
    margin: 0px auto;

    .swiper-pagination {
      position: absolute;
      width: 80px;
      font-size: 0;
      z-index: 2;
    }
  }

  .swiper-slide {
    border-radius: 8px;
    font-size: 18px;
    position: relative;

    .item {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      height: 100%;
      width: 100%;
      animation: o-upfade-top 0.7s cubic-bezier(0.4, 0, 0.2, 1) forwards;
    }

    .text-box {
      transform: translateY(20px);
      opacity: 0;
      transition: all .4s;
      box-sizing: border-box;

      .date {
        font-size: 14px;
        color: #bfbfbf;
      }

      .title {
        color: #3e3a39;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .content {
        font-size: 16px;
        line-height: 2em;
        color: #3e3a39;
        margin-top: 16px;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .ani-slide .item .text-box {
    transform: translateY(0px);
    opacity: 1;
  }
}

.ad-mian {
  width: 100%;

  .news {
    width: 100%;
    margin-bottom: 10px
  }

  .btn {
    margin-top: 40px;
    display: flex;
    justify-content: center;
    grid-gap: 10px;
    height: 40px;
  }

  .btn a {
    display: block;
    width: 120px;
    line-height: 40px;
    text-align: center;
    border: 1px solid #8c1c40;
    font-size: 14px;
    color: #8c1c40;
    transition: all .3s ease;
    text-decoration: none;
  }
}

.medium-box {
  display: flex;
  margin: 0 -5px;

  ul {
    margin: 0;
    padding: 0;
  }

  li {
    list-style: none;
  }

  .medium-width {
    display: block;
    // float: left;
    width: 50%;
    padding: 0 5px;
  }

  .medium-width-box {
    display: block;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    height: 760px;
    border-radius: 10px;
    background: url(../../assets/image/back-xz01.png) center bottom no-repeat;
    background-size: cover;
  }

  .medium-width-img div {
    height: 400px;
    border-radius: 10px;
  }

  .medium-width-box:hover .medium-title {
    color: #8c1c40;
  }

  .medium-link-span:hover {
    background: #8c1c40;
    color: #fff;
    border-color: #8c1c40;
  }

  .medium-width-bottom {
    padding: 40px;
  }

  .medium-date {
    color: #bfbfbf;
    font-size: 16px;
  }

  .medium-date span {
    display: inline-block;
    font-size: 50px;
    font-weight: bold;
    line-height: 1;
  }

  .medium-title {
    font-size: 30px;
    color: #000;
    text-align: justify;
    line-height: 35px;
    height: 70px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-top: 15px;
  }

  .medium-width-p {
    font-size: 18px;
    color: #000;
    opacity: 0.5;
    text-align: justify;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-top: 15px;
    line-height: 25px;
    height: 50px;
  }

  .medium-link-span {
    background: #fff;
    border: solid 1px #ddd;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.8);
    width: 124px;
    line-height: 34px;
    display: inline-block;
    margin-top: 30px;
    text-align: center;
  }

  .medium-width-news li a {
    display: block;
    position: relative;
    height: 190px;
    padding: 50px 35px 0 35px;
    text-decoration: none;
    box-sizing: border-box;
  }

  .medium-width-news li a .medium-date {
    float: left;
  }

  .medium-width-news-right {
    margin-left: 80px;
  }

  .medium-width-news-tt {
    font-size: 24px;
    color: #000;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }

  .medium-width-news li a:before {
    display: block;
    content: "";
    position: absolute;
    left: 35px;
    right: 35px;
    bottom: 0;
    border-top: solid 1px #ddd;
  }

  .medium-width-news li:last-child a:before {
    display: none;
  }

  .medium-width-news li a:hover:before {
    display: block;
    content: "";
    position: absolute;
    opacity: 0.9;
    left: 0;
    right: -65px;
    top: 0;
    bottom: 0;
    border: none;
    border-radius: 10px;
    background: #8c1c40;
  }

  .medium-width-news li a:hover .medium-date {
    position: relative;
    z-index: 10;
    color: #f6bd25;
  }

  .medium-width-news li a:hover .medium-width-news-tt {
    position: relative;
    z-index: 10;
    color: #fff;
  }

  .medium-width-news li a:hover .medium-width-p {
    position: relative;
    z-index: 10;
    color: rgba(255, 255, 255, 0.8);
  }

  .medium-width-news li a:hover i {
    position: absolute;
    left: 100%;
    width: 65px;
    top: 0;
    bottom: 0;
    background: url(../../assets/image/xz-raw.png) center no-repeat;
    z-index: 10;
  }

  .index-s2 .bot-block .child {

    overflow: visible !important;
  }

  .img-b img {
    width: 100%;
  }

  .img-b {
    padding: 0 4px 6px 4px;
  }
}

.news-box-c {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 8px 4px 1px 4px;

  .news-box-w {
    display: flex;
  }

  ul {
    margin: 0;
    padding: 0;
  }

  .xz-date {
    color: #bfbfbf;
    font-size: 16px;
  }

  .xz-date span {
    display: inline-block;
    font-size: 50px;
    font-weight: bold;
    line-height: 1;
  }

  .xz-title {
    font-size: 30px;
    color: #000;
    text-align: justify;
    line-height: 35px;
    height: 70px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-top: 15px;
  }

  .xz-width-p {
    font-size: 18px;
    color: #000;
    opacity: 0.5;
    text-align: justify;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-top: 5px;
    line-height: 25px;
    height: 50px;
  }


  .xz-width-news-right {
    height: 100%;
    padding: 45px 0 0;
    margin-left: 80px;
    box-sizing: border-box;
  }

  .xz-width-news-tt {
    font-size: 24px;
    color: #000;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }



  .news-box-sm {
    width: 50%;
    padding: 0 4px;
    // float: left;
  }


  .news-box-sm li a {
    display: block;
    height: 143px;
    border-radius: 10px;
    padding: 45px 50px 0 50px;
    background: url(../../assets/image/news-back-t02.png) center no-repeat;
    background-size: cover;
    box-sizing: border-box;
    text-decoration: none;
  }

  .news-box-sm li a .xz-date {
    float: left;
    color: #8c1c40;
  }

  .news-box-sm li.active a {
    height: 292px;
  }

  .news-box-sm li {
    list-style: none;
  }

  .news-box-sm li {
    padding-bottom: 8px;
  }

  .news-box-sm li a {
    position: relative;
  }

  .news-box-sm li a .xz-width-news-right {
    margin-left: 95px;
    position: absolute;
    left: 50px;
    top: 50%;
    transform: translate(0, -50%);
    right: 50px;
  }

  .news-box-sm li.active a {
    background: url(../../assets/image/news-back-t.png) center no-repeat;
    background-size: cover;
  }

  .news-box-sm li.active a .xz-date {
    float: none;
    margin-bottom: 25px;
  }

  .news-box-sm li.active a .xz-width-news-right {
    margin-left: 0;
  }

  .news-box-sm li.active a .xz-width-news-tt {
    margin-bottom: 25px;
  }

  .news-box-sm li a:hover {
    background: #8c1c40;
  }

  .news-box-sm li a:hover .xz-width-p {
    color: #fff;
    opacity: 0.8;
  }

  .news-box-sm li a:hover .xz-date {
    color: #f6bd25;
  }

  .news-box-sm li a:hover .xz-width-news-tt {
    color: #fff;
  }

  .news-box-sm li.active a .xz-width-news-tt {
    -webkit-line-clamp: 1;
  }

  .news-box-sm li.active a:hover {
    background-color: #8c1c40;
  }

  .news-box-sm li.active a:hover .xz-width-p {
    color: #fff;
    opacity: 0.8;
  }

  .news-box-sm li.active a .xz-width-news-right {
    position: static;
    transform: translate(0, 0);
  }

  .bot-block .child {

    overflow: visible !important;
  }

  .img-b img {
    width: 100%;
  }

  .img-b {
    padding: 0 4px 6px 4px;
  }
}

.main {
  width: 100%;

  .banner {
    width: 100%;
    position: relative;

    .swiper-container {
      width: 100%;
      height: 100%;
      margin: 0px auto;

      .swiper-slide {

        img,
        video {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .swiper-button-prev,
      .swiper-button-next {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        line-height: 60px;
        transform: translateY(-50%);
        font-size: 16px;
        font-weight: 700;
        background: #dedede;
        user-select: none;
        color: #282240;
        --swiper-navigation-size: 16px;
      }
    }

    .banner-img {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
        transition: all .5s;
      }
    }
  }

  .ad-box {
    // height: 500px;
    margin: 0 auto;
    position: relative;
    z-index: 1;
    padding-bottom: 100px;

    .ad-title {
      display: flex;
      justify-content: space-between;
      font-size: 20px;
      flex-wrap: wrap;
      font-weight: 400;

      .index-label {
        color: #333333;
      }

      .sub-title {
        display: flex;
      }

      .sub-title-item {
        width: 8em;
        font-size: 16px;

        &.active {
          color: #8c1c40;
          font-weight: bold;
        }

        &:hover {
          color: #8c1c40;
          font-weight: bold;
        }
      }
    }
  }

  .xs-main {
    width: 100%;
    height: 500px;
    position: relative;
    background: url('/static/38931295_l_WD2-scaled 1.png') no-repeat;
    background-size: 100% 100%;

    .box-bg {
      width: 100%;
      height: 500px;

      img {
        width: 100%;
        height: 500px;
      }
    }

    .xs-box {
      position: relative;
      width: 100%;
      height: 500px;

      background: #0066b49d;

      .xs-title {
        font-size: 20px;
        font-weight: 400;
        color: white;
        cursor: pointer;
        margin: 0 auto;
        padding: 40px 0 20px;
      }

      .xs-list {
        height: 400px;
        cursor: pointer;
        margin: 0 auto;

        .xs-info {
          width: 250px;
          height: 340px;
          margin-right: 65px;
          background: white;

          position: relative;

          img {
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
            width: 250px;
          }

          .sx-middle {
            width: 200px;
            margin: 20px auto;

            .sx-title {
              font-size: 16px;
              color: #8c1c40;
              cursor: pointer;
            }

            .sx-date {
              font-size: 12px;
              color: #666666;
              margin: 10px 0;
            }

            .sx-line {
              width: 60px;
              border-bottom: 3px solid #8c1c40;
              margin-bottom: 10px;
            }

            .sx-detial {
              font-size: 12px;
              color: #666666;
              cursor: pointer;
            }
          }

          .sx-bottom {
            position: absolute;
            bottom: 5px;
            right: 5px;
          }
        }

        .xs-info:nth-last-of-type(1) {
          margin-right: 0;
        }
      }
    }
  }

  .tz-box {
    margin: 30px auto;

    .tz-title {
      font-size: 20px;
      height: 100px;
      line-height: 100px;
      font-weight: 400;

      img {
        position: relative;
        top: 8px;
        margin-right: 5px;
      }
    }

    .tz-left {
      width: 800px;

      .tz-main {
        box-sizing: border-box;
        width: 370px;
        margin-right: 20px;
        border: 1px solid #b3b3b3;
        padding: 20px;

        .main-title {
          font-size: 18px;
          margin-bottom: 10px;
        }

        .main--detial {
          font-size: 16px;
          color: #302e2e;
          margin-bottom: 10px;
        }

        .tz-date {
          font-size: 14px;
          color: rgb(255, 142, 14)
        }
      }
    }

    .tz-right {
      width: 400px;

      .zp-box {
        .zp-list {
          margin-bottom: 8px;

          .zp-list-left {
            width: 300px;
          }

          .zp-list-date {
            width: 80px;

            font-size: 12px;
            color: #666666;
          }
        }
      }
    }
  }
}

.index-s3 {

  background-color: #fff;
  position: relative;

  &:before {
    content: '';
    width: 100%;
    height: 36vw;
    position: absolute;
    top: -15vw;
    left: 0;
    background: url("../../assets/image/img-3.png") center top no-repeat;
    background-size: 100% auto;
    pointer-events: none;
  }

  .index-label {
    font-size: 36px;
    color: #333333;
  }

  .index-wrap {
    margin: 0 auto;
    position: relative;
    z-index: 3;
  }

  .tab-cont .child {
    display: none;
  }

  .tab-cont .child.active {
    display: block;
  }

  .tab-cont .child.active .flex {
    animation: o-upfade-top 0.7s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  }

  .tab-cont .child.active .tit {
    animation-delay: .1s;
  }

  .tab-cont .child.active p {
    animation-delay: .2s;
  }

  .tab-cont .child.active .btn {
    animation-delay: .3s;
  }

  .tab-cont .flex {
    display: flex;
    align-items: flex-start;
    opacity: 0;
  }

  .tab-cont .txt-box {
    margin-top: 40px;
    padding: 24px 200px 24px 40px;
    width: calc(100% - 480px);
    border-left: 1px solid #e5e5e5;
    position: relative;
    z-index: 2;
  }

  .tab-cont .txt-box:before {
    content: '';
    width: 1px;
    height: 120px;
    background-color: #8c1c40;
    position: absolute;
    left: -1px;
    top: 60px;
  }

  .tab-cont .date {
    font-size: 14px;
    color: #191919;
    font-family: 'Rajdhani-Regular';
  }

  .tab-cont .tit {
    font-size: 32px;
    color: #191919;
    font-family: 'HarmonyOS_Sans_SC_Bold';
    margin-top: 24px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .tab-cont p {
    font-size: 16px;
    color: #191919;
    line-height: 2;
    margin-top: 24px;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .tab-cont .btn {
    margin-top: 100px;
    display: flex;
    grid-gap: 10px;
  }

  .tab-cont .btn a {
    display: block;
    width: 120px;
    line-height: 36px;
    text-align: center;
    border: 1px solid #8c1c40;
    font-size: 14px;
    color: #8c1c40;
    transition: all .3s ease;
    text-decoration: none;
  }

  .tab-cont .btn a:nth-of-type(1) {
    background-color: #8c1c40;
    color: #fff;
  }

  @media (any-hover: hover) {
    .tab-cont .btn a:hover {
      background-color: #8c1c40;
      color: #fff;
      transform: translateY(-3px);
      box-shadow: 0 10px 30px rgba(140, 28, 64, 0.3);
    }
  }

  .tab-cont .img-box {
    width: 480px;
    height: 640px;
    position: relative;
    order: 2;
    perspective: 800px;
  }

  .tab-cont .img-box:before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    right: 100%;
    top: 0;
    background: url("../../assets/image/img-5.png") right top no-repeat;
    background-size: auto 100%;
  }

  .tab-cont .img-box img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transform-style: preserve-3d;
    transform-origin: left center;
    transform: rotateY(15deg);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  }

  .bot-block {
    margin-top: 80px;
    position: relative;
    background-color: #f5f5f5;
  }

  .bot-block .item {
    height: 90px;
    padding: 0 60px;
    display: flex;
    align-items: center;
    transition: background .3s ease;
    cursor: pointer;
    box-sizing: border-box;
  }

  .bot-block .item:after {
    content: '';
    width: 1px;
    height: 60px;
    background-color: #dcdcdc;
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -30px;
    pointer-events: none;
    transition: opacity .3s ease;
  }

  .bot-block .item .tit {
    width: 100%;
    font-size: 14px;
    color: #191919;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: color .3s ease;
  }

  .bot-block .item.active {
    background-color: #8c1c40;
  }

  .bot-block .item.active:before {
    transform: scaleX(1);
    transform-origin: left top;
  }

  .bot-block .item.active:after {
    opacity: 0;
  }

  .bot-block .item.active .tit {
    color: #fff;
  }

  .bot-block .button {
    width: 30px;
    height: 30px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    position: absolute;
    top: 50%;
    margin-top: -15px;
    z-index: 2;
    cursor: pointer;
  }

  .bot-block .prev {
    left: 15px;
    background-image: url("../../assets/image/prev.png");
  }

  .bot-block .next {
    right: 15px;
    background-image: url("../../assets/image/next.png");
  }
}

.index-s4 {
  .index-label {
    font-size: 36px;
    text-align: center;
    color: #333333;
  }

  .items.xl {
    height: 960px;

    .sw {
      height: 100%;
      display: grid;
      grid-template-columns: repeat(4, 25%);
      grid-template-rows: repeat(2, 50%);
    }

    .item {
      position: relative;
      background-color: #000;
    }

    .item:nth-of-type(1) {
      grid-area: ~'1 / 1 / 2 / 3';
    }

    .item:nth-of-type(6) {
      grid-area: ~'2 / 3 / 3 / 5';
    }

    .item:nth-of-type(1) .hide .tit,
    .item:nth-of-type(6) .hide .tit {
      font-size: 30px;
    }

    .item .status {
      display: none;
      position: absolute;
      top: 20px;
      right: 20px;
      width: 90px;
      line-height: 30px;
      text-align: center;
      border-radius: 5px;
      font-size: 12px;
      z-index: 3;
    }

    .zt1 .notstart {
      display: block;
    }

    .zt2 .ongoing {
      display: block;
    }

    .zt3 .ended {
      display: block;
    }

    .item .status.ongoing {
      background-color: rgba(255, 255, 255, 0.5);
      color: #8c1c40;
    }

    .item .status.notstart {
      background-color: #8c1c40;
      color: #f6be25;
    }

    .item .status.ended {
      background-color: rgba(83, 83, 83, 0.5);
      color: #fff;
    }

    .item .img-box {
      width: 100%;
      height: 100%;
      overflow: hidden;
      opacity: 0.5;
      background-size: cover;
    }

    .item img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform .5s ease;
      will-change: transform;
    }

    .item .show {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 0 48px 40px;
      z-index: 1;
      transition: opacity .3s ease;
    }

    .item .show span {
      display: block;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.5);
    }

    .item .show .tit {
      font-size: 16px;
      color: #fff;
      line-height: 1.5;
      margin-top: 5px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .item .hide {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 0 48px 40px;
      z-index: 2;
      opacity: 0;
      transition: opacity .3s ease;
    }

    .item .hide .tit {
      font-size: 16px;
      color: #fff;
      line-height: 1.5;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .item .hide .info {
      margin-top: 16px;
      opacity: 0.8;
    }

    .item .hide p {
      font-size: 12px;
      color: #ffffff;
      position: relative;
      padding-left: 32px;
      margin-top: 10px;
    }

    .item .hide p:nth-of-type(1) {
      margin-top: 0;
    }

    .item .hide p:before {
      content: '';
      width: 14px;
      height: 14px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      position: absolute;
      left: 0;
      top: 2px;
    }

    .item .btn {
      margin-top: 24px;
      display: flex;
      grid-gap: 10px;
    }

    .item .btn a {
      display: block;
      width: 120px;
      line-height: 36px;
      text-align: center;
      border: 1px solid #fff;
      font-size: 14px;
      color: #fff;
      transition: all .3s ease;
      text-decoration: none;
    }

    .item .btn a:nth-of-type(1) {
      border-color: #8c1c40;
      background-color: #8c1c40;
      color: #fff;
    }

    @media (any-hover: hover) {
      .item .btn a:hover {
        border-color: #8c1c40;
        background-color: #8c1c40;
        color: #fff;
        transform: translateY(-3px);
        box-shadow: 0 10px 30px rgba(140, 28, 64, 0.3);
      }
    }

    @media (any-hover: hover) {
      .item:hover img {
        transform: scale(1.1);
      }

      .item:hover .show {
        opacity: 0;
      }

      .item:hover .hide {
        opacity: 1;
      }
    }

    .img-box1_0 {
      background: url('../../assets/image/jiangzuo-1.jpg') no-repeat;
      background-size: 100% 100%;
    }

    .img-box1_1 {
      background: url('../../assets/image/jiangzuo-2.jpg') no-repeat;
      background-size: 100% 100%;
    }

    .img-box1_2 {
      background: url('../../assets/image/jiangzuo-3.jpg') no-repeat;
      background-size: 100% 100%;
    }

    .img-box2_0 {
      background: url('../../assets/image/jiangzuo-4.png') no-repeat;
      background-size: 100% 100%;
    }

    .img-box2_1 {
      background: url('../../assets/image/jiangzuo-5.png') no-repeat;
      background-size: 100% 100%;
    }

    .img-box2_2 {
      background: url('../../assets/image/jiangzuo-6.jpg') no-repeat;
      background-size: 100% 100%;
    }
  }


}

.index-s5 {
  padding: 120px 0 0;
  margin: 0 auto;

  .index-label {
    text-align: center;
    font-size: 36px;
    color: #333333;
  }

  .items {
    margin-top: 40px;
    border-radius: 10px;
    overflow: hidden;
  }

  .sw {
    display: flex;
  }

  .btn {
    margin-top: 40px;
    display: flex;
    justify-content: center;
    grid-gap: 10px;
    height: 40px;
  }

  .btn a {
    display: block;
    width: 120px;
    line-height: 40px;
    text-align: center;
    border: 1px solid #8c1c40;
    font-size: 14px;
    color: #8c1c40;
    transition: all .3s ease;
    text-decoration: none;
  }

  .btn a:hover {
    background-color: #8c1c40;
    color: #fff;
    transform: translateY(-3px);
    box-shadow: 0 5px 20px rgba(140, 28, 64, 0.3);
  }

  .xs5item {
    width: 170px;
    height: 640px;
    overflow: hidden;
    position: relative;
    transition: width .3s ease;
    display: block;
    position: relative;
    z-index: 2;
  }

  .xs5item:before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #8c1c40;
    pointer-events: none;
    transition: opacity .3s ease;
    z-index: 1;
  }

  .xs5item .img-box {
    width: 930px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    background-color: #000;
    z-index: 1;
    opacity: 0.1;
    transition: opacity .3s ease;
  }

  .xs5item .img-box img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.9;
  }

  .xs5item .show {
    width: 170px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    padding-top: 280px;
    z-index: 2;
    transition: all .3s ease;
  }

  .xs5item .show i {
    display: block;
    width: 42px;
    height: 42px;
    margin: 0 auto;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }

  .xs5item .show .tit {
    padding: 0 20px;
    margin-top: 20px;
    font-size: 14px;
    color: #fff;
    text-align: center;
  }

  .xs5item .hide {
    width: 930px;
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 60px;
    z-index: 3;
    background-image: linear-gradient(180deg, transparent, rgba(0, 0, 0, 0.8));
    opacity: 0;
    visibility: hidden;
    transition: all .3s ease;
  }

  .xs5item .hide .tit {
    font-size: 36px;
    color: #fff;
    font-family: 'HarmonyOS_Sans_SC_Bold';
  }

  .xs5item .hide p {
    font-size: 14px;
    color: #fff;
    line-height: 1.5;
    font-family: 'HarmonyOS_Sans_SC_Light';
    margin-top: 16px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .xs5item .hide span {
    display: block;
    width: 120px;
    line-height: 36px;
    text-align: center;
    border: 1px solid #fff;
    font-size: 14px;
    color: #fff;
    margin-top: 20px;
    transition: all .3s ease;
  }

  .xs5item .hide span:hover {
    border-color: #8c1c40;
    background-color: #8c1c40;
  }

  .xs5item:nth-of-type(2):before {
    opacity: 0.85;
  }

  .xs5item:nth-of-type(3):before {
    opacity: 0.7;
  }

  .xs5item:nth-of-type(4):before {
    opacity: 0.55;
  }

  .xs5item.active {
    width: 930px;
  }

  .xs5item.active:before {
    opacity: 1;
  }

  .xs5item.active .img-box {
    opacity: 1;
  }

  .xs5item.active .show {
    opacity: 0;
    visibility: hidden;
  }

  .xs5item.active .hide {
    opacity: 1;
    visibility: visible;
  }
}

@keyframes o-ani5-1 {

  0%,
  100% {
    transform: translateY(0);
  }

  60% {
    transform: translateY(-10px);
  }
}

.index-s8 {
  margin: 100px 0 0;
  padding-bottom: 400px;
  position: relative;
  z-index: 1;
  overflow: hidden;

  .top-block {
    font-size: 48px;
    font-weight: 900;
    text-align: center;
  }

  .top-block img {
    display: block;
    width: 350px;
    margin: 0 auto;
  }

  .bot-block {
    max-width: 1920px;
    margin: 0 auto;
    display: flex;
    padding: 0 90px;
    justify-content: space-between;
    align-items: flex-start;
  }

  .item {
    position: relative;
    animation: o-ani5-1 2s linear infinite;
  }

  .item:after {
    content: '';
    display: block;
    width: 160px;
    height: 76px;
    margin: 5px auto 0;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url("../../assets/image/img-16.png");
    transition: opacity .3s ease;
  }

  .item .box {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 160px;
    height: 160px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .item .box:before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 50%;
    border: 1px dashed #8c1c40;
    background-color: #fff;
    z-index: -1;
    pointer-events: none;
    opacity: 0;
    transition: opacity .3s ease;
  }

  .item .icon {
    width: 160px;
    height: 74px;
    margin: 0 auto;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    opacity: 0;
    transition: opacity .3s ease;
  }

  .icon1 {
    background-image: url(../../assets/image/1-kyxmjf.png);
  }

  .icon2 {
    background-image: url(../../assets/image/2-fmzl.png);
  }

  .icon3 {
    background-image: url(../../assets/image/3-hybz.png);
  }

  .icon4 {
    background-image: url(../../assets/image/4-shfw.png);
  }

  .icon5 {
    background-image: url(../../assets/image/5-kytd.png);
  }

  .icon6 {
    background-image: url(../../assets/image/6-rzyjs.png);
  }

  .icon7 {
    background-image: url(../../assets/image/7-kysbjz.png);
  }

  .item span {
    font-size: 48px;
    color: #0457C7;
    font-family: 'Rajdhani-Bold';
    line-height: 70px;
    line-height: 1;
    margin-top: 16px;
    transition: color .3s ease;
  }

  .item p {
    padding-top: 160px;
    font-size: 14px;
    color: #0457C7;
    text-align: center;
    transition: all .3s ease;
  }

  .item:nth-of-type(1) {
    margin-top: 32px;
    animation-delay: .2s;
  }

  .item:nth-of-type(2) {
    margin-top: 120px;
    animation-delay: .5s;
  }

  .item:nth-of-type(4) {
    margin-top: 200px;
    animation-delay: .6s;
  }

  .item:nth-of-type(5) {
    margin-top: 120px;
    animation-delay: .3s;
  }

  .item:nth-of-type(6) {
    margin-top: 256px;
    animation-delay: .7s;
  }

  .item:nth-of-type(7) {
    margin-top: 160px;
    animation-delay: .3s;
  }

  .item:nth-of-type(8) {
    margin-top: 128px;
    animation-delay: .4s;
  }

  .item:hover {
    animation-play-state: paused;
  }

  .item:hover:after {
    opacity: 0;
  }

  .item:hover .box:before {
    opacity: 1;
  }

  .item:hover .icon {
    opacity: 1;
  }

  .item:hover span {
    color: #8c1c40;
  }

  .item:hover p {
    color: #8c1c40;
    transform: translateY(16px);
  }

  .bg-img {
    width: 100%;
    height: 100%;
    min-width: 1400px;
    position: absolute;
    top: 0;
    z-index: -1;
    // opacity: 0.4;
  }
}


@media screen and (min-width: 1025px) {
  .main {
    min-width: 1460px;
  }

  .main .banner {
    height: 100vh;
  }

  .ad-box {
    width: 1460px;

    .ad-title {
      height: 100px;
      line-height: 100px;

      .index-label {
        font-size: 36px;
      }

      .sub-title {
        justify-content: flex-end;

        .sub-title-item {
          text-align: right;
        }
      }
    }

    .news {
      height: 380px;
      width: 100%;

      .swiper-slide {
        width: 100%;

        img {
          width: 720px;
          height: 380px;
          transition-duration: 1s;
          border-top-left-radius: 8px;
          border-bottom-left-radius: 8px;
        }

        .text-box {
          width: 50%;
          padding: 80px 60px 120px;

          .title {
            font-size: 32px;
            color: #3e3a39;
            margin-top: 16px;
          }
        }
      }

      .swiper-pagination {
        left: calc(50% + 60px);
        bottom: 60px;
        text-align: left;
      }
    }

    .newsList {
      .news-item {
        width: calc((100% - 30px) / 4);
        height: 270px;
      }
    }
  }

  .index-s3 {
    .xl {
      display: block;
    }

    .sm {
      display: none;
    }
  }

  .index-s4 {
    .items.xl {
      display: block;
    }

    .items.sm {
      display: none;
    }
  }

  .index-wrap {
    width: 1460px;
  }

  .xueshudongtai {
    width: 1460px;
  }

  .xs-title {
    width: 1460px;
  }

  .xs-list {
    width: 1460px;
  }

  .tz-box {
    width: 1460px;
  }

  .index-s5 {
    width: 1460px;

    .xl {
      display: block;
    }

    .sm {
      display: none;
    }
  }
}

@media screen and (max-width: 1025px) {
  .main {
    width: 100%;
  }

  // .main .banner {
  //   height: 260px;
  // }

  .ad-box {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;

    .ad-title {
      line-height: 2em;

      .index-label {
        font-size: 20px;
        font-weight: 600;
        width: 100%;
        text-align: center;
      }

      .sub-title {
        width: 100%;
        justify-content: center;

        .sub-title-item {
          text-align: center;
        }
      }
    }

    .news {
      box-sizing: border-box;
      border-radius: 8px;

      .swiper-slide {
        img {
          width: 100%;
          height: 35vh;
          transition-duration: 1s;
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
        }

        .text-box {
          width: 100%;
          padding: 20px 15px 40px;

          .title {
            font-size: 18px;
            margin-top: 5px;
            font-weight: 600;
          }
        }
      }

      .swiper-pagination {
        left: calc(50% - 40px);
        bottom: 20px;
        text-align: center;
      }
    }

    .newsList {
      .news-item {
        width: calc((100% - 20px) / 2);
        margin-bottom: 10px;

        img {
          height: 15vh;
        }

        .text-box {
          padding: 12px 16px;
        }
      }
    }

    .medium-box {
      flex-wrap: wrap;

      .medium-width {
        width: 100%;
      }

      .medium-width-box {
        height: auto;
        margin-bottom: 10px;
      }

      .medium-width-bottom {
        padding: 15px;

        .medium-date span {
          font-size: 30px
        }

        .medium-title {
          font-size: 22px;
          -webkit-line-clamp: 3;
          line-height: 1.5em;
          height: 100px;
        }

        .medium-link-span {
          margin-top: 20px;
        }
      }

      .medium-width-news {
        li a {
          padding: 15px;

          .medium-date span {
            font-size: 30px
          }

          .medium-width-news-tt {
            font-size: 18px;
            -webkit-line-clamp: 3;
          }
        }
      }
    }

    .news-box-c {
      .news-box-w {
        flex-wrap: wrap
      }

      .news-box-sm {
        width: 100%;

        li a {
          padding: 15px;
          height: auto;

          .xz-date span {
            font-size: 30px
          }

          .xz-width-news-tt {
            font-size: 18px;
            -webkit-line-clamp: 2;
          }

          .xz-width-p {
            font-size: 16px;
            -webkit-line-clamp: 1;
          }

          .xz-width-news-right {
            right: 15px;
            padding-top: 10px;
            margin-left: 50px;
          }
        }

        li.active .xz-width-news-right {
          margin-left: 0;
        }
      }
    }
  }

  .index-s3 {

    .xl {
      display: none;
    }

    .sm {
      display: block;
    }

    //科研创新
    .index-label {
      font-size: 20px;
      font-weight: 600;
      width: 100%;
      text-align: center;
    }

    .kycx2-swiper-container {
      padding-bottom: 20px;
    }

    .tab-cont {
      overflow-x: hidden;
    }

    .tab-cont .flex1 {
      margin-top: 20px;

      .img-box {
        width: 60%;
        height: 45vh;
        margin: 10px auto 0;
      }

      .txt-box {
        width: 100%;
        padding: 20px;
        margin: 10px 0;
        box-sizing: border-box;


        &::before {
          display: none;
        }

        .tit {
          font-size: 18px;
          font-weight: 600;
        }

        .btn {
          margin-top: 10px;
          justify-content: center;
        }
      }
    }
  }

  .index-s4 {
    padding-top: 20px;
    width: 100%;
    overflow: hidden;

    .index-label {
      font-size: 20px;
      font-weight: 600;
      width: 100%;
      text-align: center;
    }

    .items.xl {
      display: none;
    }

    .items.sm {
      position: relative;
      padding-bottom: 15px;
      box-sizing: border-box;
      width: 100%;

      .jzbg-swiper-container,
      .yjsfc-swiper-container {
        padding-bottom: 25px;
        position: relative;
      }

      .item {
        position: relative;
        display: block;
        margin: 20px;
        background-color: #000;
        border-radius: 12px;
      }

      .item .img-box {
        width: 100%;
        height: 50vh;
        overflow: hidden;
        opacity: 0.5;
        background-size: cover;
        border-radius: 12px;
        background-position: center;
      }

      .img-box1_0 {
        background: url('../../assets/image/jiangzuo-1.jpg') no-repeat;
        background-size: 100% 100%;
      }

      .img-box1_1 {
        background: url('../../assets/image/jiangzuo-2.jpg') no-repeat;
        background-size: 100% 100%;
      }

      .img-box1_2 {
        background: url('../../assets/image/jiangzuo-3.jpg') no-repeat;
        background-size: 100% 100%;
      }

      .img-box2_0 {
        background: url('../../assets/image/jiangzuo-4.png') no-repeat;
        background-size: 100% 100%;
      }

      .img-box2_1 {
        background: url('../../assets/image/jiangzuo-5.png') no-repeat;
        background-size: 100% 100%;
      }

      .img-box2_2 {
        background: url('../../assets/image/jiangzuo-6.jpg') no-repeat;
        background-size: 100% 100%;
      }

      .item .hide {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 2;
        width: 100%;
        padding: 20px;
        box-sizing: border-box;
      }

      .item .hide .tit {
        font-size: 16px;
        color: #fff;
        line-height: 1.5;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .item .hide .info {
        margin-top: 16px;
        opacity: 0.8;
      }

      .item .hide p {
        font-size: 12px;
        color: #ffffff;
        position: relative;
        margin-top: 10px;
      }

      .item .hide p:nth-of-type(1) {
        margin-top: 0;
      }

      .item .hide p:before {
        content: '';
        width: 14px;
        height: 14px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        position: absolute;
        left: 0;
        top: 2px;
      }

      .item .btn {
        margin-top: 24px;
        display: flex;
        grid-gap: 10px;
      }

      .item .btn a {
        display: block;
        width: 100px;
        line-height: 30px;
        text-align: center;
        border: 1px solid #fff;
        font-size: 12px;
        color: #fff;
        transition: all .3s ease;
        text-decoration: none;
      }

      .item .btn a:nth-of-type(1) {
        border-color: #8c1c40;
        background-color: #8c1c40;
        color: #fff;
      }
    }
  }

  .xueshudongtai {
    width: 100%;
  }

  .xs-title {
    width: 100%;
  }

  .xs-list {
    width: 100%;
  }

  .tz-box {
    width: 100%;
  }

  .index-wrap {
    width: 100%;
  }

  .index-s5 {
    width: 100%;
    padding-top: 20px;

    .index-label {
      font-size: 20px;
      font-weight: 600;
    }

    .xl {
      display: none;
    }

    .sm {
      display: block;
      position: relative;
      padding-bottom: 20px;
      margin-top: 0;
    }


    .item {
      margin: 20px;
      border-radius: 12px;

      .img-box {
        img {
          border-radius: 12px;
          width: 100%;
          height: 40vh;
        }
      }

      .tit {
        font-size: 16px;
        font-weight: 600;
        margin-top: 20px
      }
    }
  }

  .index-s8 {
    padding-bottom: 0;
    overflow: unset;

    .bg-img {
      height: auto;
      top: unset;
      bottom: -10%;
      min-width: unset;
      object-fit: contain;
    }

    .top-block img {
      width: 300px;
    }

    .bot-block {
      flex-wrap: wrap;
      padding: 0 20px;

      .item {
        width: 50%;
        padding: 0;
        animation: none;
        margin-top: 20px;

        .box {
          width: 120px;
          height: 120px;
        }

        .box:before {
          opacity: 1;
        }

        .icon {
          width: 120px;
          height: 60px;
          opacity: 1;
        }

        span {
          font-size: 36px;
          margin-top: 5px;
          color: #8c1c40;
        }

        p {
          padding-top: 100px;
          color: #8c1c40;
          transform: translateY(16px);
        }

        &:after {
          display: none;
        }
      }
    }
  }
}

@media screen and (max-width: 750px) {
  .bg-img {
    bottom: -15%;
  }
}
</style>